import React from "react";
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Box from "@amzn/meridian/box";
import { usePageHeader } from "./hooks";

const PageHeader: React.FC = () => {
    const { pageHeader } = usePageHeader();
    const { title, description, actions } = pageHeader;

    return (
        <Row width="100%" widths={["grid-7", "grid-2", "grid-3"]}>
            <Box>
                <Heading level={1} type="d50">
                    {title}
                </Heading>
                <Heading color={"secondary"} type="b300" level={1}>
                    {description ?? ""}
                </Heading>
            </Box>
            {actions}
        </Row>
    );
};

export default PageHeader;
